import {
  importProvidersFrom,
  inject,
  provideEnvironmentInitializer,
} from '@angular/core';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import {
  SOFTLINE_SERVICE_HTTP,
  SOFTLINE_STORE_REMOTE_OBJECT_SERVICE,
  SoftlineObjectService,
  Store,
  StoreModule,
} from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from './../i18n/de.json';
import { default as deTitles } from './../i18n/de.titles.json';
import { SOFTLINE_API_WWS_ARTIKELBASISSTAND } from './basisartikelstand.api';
import {
  SOFTLINE_FEATURE_WWS_BASISARTIKELSTAND,
  SOFTLINE_PERMISSION_WWS_BASISARTIKELSTAND,
} from './basisartikelstand.shared';
import { basisartikelstandRoutes } from './basisartikelstand.routes';
import { provideBasisartikelstandGlobals } from './basisartikelstand.globals';
import { WwsBasisartikelstandStore } from './store/basisartikelstand.store';

export function provideBasisartikelstandModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'wws/basisartikelstand',
        title: 'Basisartikelstand',
        icon: 'fa-regular fa-chart-bar',
        route: '/basisartikelstand',
        permission: SOFTLINE_PERMISSION_WWS_BASISARTIKELSTAND,
        group: getModuleGroupByName('Stammdaten'),
      },
      withSoftAppsModuleRoutes({ app: basisartikelstandRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('./../i18n/de.json') },
      }),
      withSoftAppsModuleInfo({
        library: '@softapps/wws/basisartikelstand',
        description: 'Basisartikelstand abfragen.',
      })
    ),
    ...provideBasisartikelstandGlobals(),
  ];
}

export const basisartikelstandProviders = [
  provideEnvironmentInitializer(async () => {
    const store = inject(Store);

    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'wwsBasisartikelstand',
      language: 'de',
      translations: de,
    });

    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: 'Basisartikelstand',
      route: '/basisartikelstand',
      icon: 'fa-regular fa-chart-bar',
      permission: SOFTLINE_PERMISSION_WWS_BASISARTIKELSTAND,
      group: getModuleGroupByName('Stammdaten'),
    });
  }),
  importProvidersFrom(
    StoreModule.forFeature({
      feature: WwsBasisartikelstandStore.feature,
      name: SOFTLINE_FEATURE_WWS_BASISARTIKELSTAND,
      providers: [
        {
          provide: SOFTLINE_STORE_REMOTE_OBJECT_SERVICE,
          useFactory: () =>
            new SoftlineObjectService(
              inject(SOFTLINE_SERVICE_HTTP),
              SOFTLINE_API_WWS_ARTIKELBASISSTAND
            ),
        },
      ],
    })
  ),
];
